import { Separator } from '@change/ds-core-ui';

import { EmailVerificationModal, LoginModal } from 'src/app/shared/components/payments';

import {
	Headline,
	HighAmountConfirmationModal,
	ImpressionAmountSelector,
	ImpressionCalculation,
	OverwritePaymentMethodConfirmationModal,
	PaymentMethods,
	ShareActions,
} from '../components';

import { useContainer } from './hooks/useContainer';

export const PromoteFormBodyContainer: React.FC = () => {
	const {
		data: { displayed },
	} = useContainer();

	if (!displayed) return null;

	return (
		<>
			<Separator className="my-0" />
			<Headline />
			<div className="flex flex-col gap-2">
				<ImpressionAmountSelector />
				<ImpressionCalculation />
			</div>
			<PaymentMethods />
			<ShareActions />
			<HighAmountConfirmationModal />
			<OverwritePaymentMethodConfirmationModal />
			<LoginModal />
			<EmailVerificationModal />
		</>
	);
};
